import {Store} from "@7egend/web.core"
import { LOAD_COUNTRIES_ACTION_KEY } from "./types"
import { CountriesGetInput } from "../../dlos/country";

export function loadCountries() {
    const request = new CountriesGetInput()
    return Store.utils.actionDefaultProcessor(LOAD_COUNTRIES_ACTION_KEY, request)
}
